import { SKILL_OWNER_TOKENS, type SkillOwner } from "../../SkillAccess/skillAccessTokens";

/** Globe (Encamp), building (your organization) or lock (only you). Decorative. */
export function SkillOwnerIcon({ owner, size }: { owner: SkillOwner; size: number }) {
  const { Icon } = SKILL_OWNER_TOKENS[owner];
  return <Icon aria-hidden sx={{ fontSize: size }} />;
}
